import { safeStringify } from '@ninjacart/nc-nk-core';

import { QnAAnswersWithComments, QuestionAnswerCard } from '@ninjacart/nc-nk-adaptive-cards';
import {
  IGlobalSearchTab,
  IQnACommentResponseItem,
  IQnADetailPayload,
  IQnAReplyItem,
  IQuestionAnswer,
} from '@ninjacart/nc-nk-core';
import { INinjaEvent, addEventParam, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import {
  DiscoveryCardType,
  IPostQuestionBody,
  IPostQuestionPayload,
  KissanEventType,
  LanguageJson,
  isInvalidPostOwnerId,
  postQuestionReplyAsync,
  useAppPersistenceStore,
  useGlobalLoginContext,
  useProfileStore,
} from '@ninjacart/nc-nk-store';
import {
  Button,
  Input,
  NavHeaderComponent,
  Paragraph,
  RootContainer,
  ScrollView,
  Separator,
  Spinner,
  Stack,
  TextArea,
  UIBottomSheet,
  View,
  XStack,
  useTheme,
  useToastController,
} from '@ninjacart/nc-nk-ui';
import { BannerAds, useNavigation, useRouter } from '@ninjacart/nc-nk-web-deps';
import { FlashList } from '@shopify/flash-list';
import { SendHorizontal } from '@tamagui/lucide-icons';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dimensions, GestureResponderEvent, Keyboard, Platform } from 'react-native';
import { useParams } from 'solito/navigation';
import {
  createCommentQnA,
  getAllQnADetail,
  getQnACommentList,
  onQnAReplyLike,
} from '../../api/kisan/getAllQnAList';
import { useQnaFeedStore } from '../../store/useQnaStore';
import { QnAPlaceHolder } from './qnaPlaceholder';
import { QnaSubmitFeedback } from './qnaSubmitFeedback';
import { useFeatureFlag } from '@ninjacart/nc-nk-ff4j';

const useParam = useParams<{ id: string }>;

export const QuestionAnswerDetail = ({ qnaId, lang }: { qnaId: string; lang?: string }) => {
  const [qnaFeedbackbottomSheet, setQnaFeedbackbottomSheet] = useState<boolean>(false);
  const { id: qnaDetailId } = useParam();
  const { t } = useTranslation();
  const { push } = useRouter();
  const selectedLanguage = useAppPersistenceStore((state) => state.appLanguage);
  // const setCommentReplyExpanded = useQnaFeedStore((state) => state.setCommentReplyExpanded);
  const userProfile = useProfileStore((state) => state.userProfile);
  const setCommentInputHidden = useQnaFeedStore((state) => state.setCommentInputHidden);
  const isCommentInputHidden = useQnaFeedStore((state) => state.isCommentInputHidden);
  const startCountRef = useRef({ page: 0, limit: 10 });
  const [questionDetail, setQuestionDetail] = useState<IQuestionAnswer>();
  const [questionAnswer, setQuestionAnswer] = useState<IQnAReplyItem[]>([]);
  const textAreaRef = useRef<Input>(null);
  const [addReply, setAddReply] = useState('');
  const [commentList, setCommentList] = useState<IQnACommentResponseItem[]>([]);
  // const [commentReplyExpanded, setCommentReplyExpanded] = useState(false);
  const [onEndReachedSpinner, setOnEndReachedSpinner] = useState<boolean>(false);
  // const [expertAnswers, setExpertAnswers] = useState<
  //   IQnAReplyItem[]
  // >([]);
  // const [otherAnswers, setOtherAnswers] = useState<
  //   IQnAReplyItem[]
  // >([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);
  const theme = useTheme();
  const nav = useNavigation();
  // const [guestUserBottomSheet, setGuessUserBottomSheet] = useState<boolean>(false);
  const authorIdRef = useRef('');
  const isAskQuestionDetailPage = useQnaFeedStore((state) => state.isAskQuestionDetailPage);
  const [isAnswerSubmitting, setIsAnswerSubmitting] = useState<boolean>(false);
  const hasQuestionAnswered = useQnaFeedStore((state) => state.hasQuestionAnswered);
  const setHasQuestionAnswered = useQnaFeedStore((state) => state.setHasQuestionAnswered);
  const removeViewedQuestionId = useQnaFeedStore((state) => state.removeViewedQuestionId);
  const deviceWidth = Dimensions.get('window').width;
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const [extraData, setExtraData] = useState(false);
  const toast = useToastController();
  const fields = useGlobalLoginContext(['openLoginSheet', 'previousPage', 'navigationParams']);
  const setNavigationParams = fields.navigationParams.set;
  const questionId = qnaDetailId ?? qnaId;
  const id = questionId?.includes('-') ? questionId?.split('-').pop() : questionId;
  console.log('questionId ***', id);
  const uniqueDeviceId = useAppPersistenceStore((state) => state.deviceId);
  const requestQnAFeatureFlow = useFeatureFlag(
    'requestQnAFeatureFlow',
    'UserDeviceId',
    uniqueDeviceId!
  );

  const [qnaNewFlow, setQnaNewFlow] = useState({
    name: requestQnAFeatureFlow ? '/askQuestionSearch' : '/qna/create',
    routeName: requestQnAFeatureFlow ? 'askQuestionSearch/index' : 'qna/create/index',
  });

  const getQnADetails = async () => {
    const payload: IQnADetailPayload = {
      userId: useProfileStore?.getState()?.userProfile?.user?.id ?? '1',
      realmId: useProfileStore?.getState()?.userProfile?.realm?.id ?? '1',
      id: id?.toString(),
    };
    if (!id) return;
    try {
      const res = await getAllQnADetail(payload);
      const qId = res?.id;
      if (qId && hasQuestionAnswered[qId]) {
        const expertAnswer = res?.children?.find(
          (x) => x?.type == 'QNA' && x?.creatorRole === 'mods'
        );
        if (expertAnswer) {
          setHasQuestionAnswered(qId, 'isBannerClosed', true);
          removeViewedQuestionId(qId);
        }
      }
      authorIdRef.current = res?.author?.creatorid;
      const tranformedToAdaptive: IQnAReplyItem[] = res?.children?.map((item) => {
        const content = item?.['actionData']?.['content'];
        const type = item?.['type'];
        return {
          ...content,
          type,
        };
      });
      res.children = tranformedToAdaptive;
      setQuestionDetail(res);

      console.log('🚀 ~ getQnADetails ~ tranformedToAdaptive:', tranformedToAdaptive);
      setQuestionAnswer(tranformedToAdaptive ?? []);
      // if (res?.children) {
      //   getCommentsByType(res?.children);
      // }
      setIsLoading(false);
      return res;
    } catch (error) {
      console.log('All QnA List Error', error);
    } finally {
      if (authorIdRef.current) {
        handleAnswerPageSuccess();
      }
    }
  };

  async function initializeQnADetails() {
    setIsLoading(true);
    await getQnADetails();
    // await getAllComments();
  }

  const handleAnswerPageSuccess = () => {
    if (authorIdRef.current === userProfile?.user?.id) {
      const selfAnswerViewEvent: INinjaEvent = {
        name: KissanEventType.SELF_ANSWER_VIEW,
        screenDetails: { screen: 'qna detail page' },
        eventParams: [
          addEventParam('questionId', id),
          addEventParam('authorId', authorIdRef.current),
        ],
      };
      enqueue(selfAnswerViewEvent);
    } else {
      const qnaAnswerBoxOpenSuccessEvent: INinjaEvent = {
        name: KissanEventType.QNA_ANSWERBOXOPEN_SUCCESS,
        screenDetails: { screen: 'qna detail page' },
        eventParams: [
          addEventParam('questionId', id),
          addEventParam('authorId', authorIdRef.current),
        ],
      };
      enqueue(qnaAnswerBoxOpenSuccessEvent);
    }
  };
  useEffect(() => {
    initializeQnADetails();
  }, []);

  // const getCommentsByType = (replies: IQnAReplyItem[]) => {
  //   const expertAnswers: IQnAReplyItem[] = replies.filter(
  //     (x) => x?.type == 'QNA' && x?.creatorRole === 'mods'
  //   );
  //   const otherAnswers: IQnAReplyItem[] = replies.filter(
  //     (x) => x?.type == 'QNA' && x?.creatorRole !== 'mods'
  //   );
  //   setExpertAnswers(expertAnswers);
  //   setOtherAnswers(otherAnswers);
  // };

  const onReplyToQuestion = async (e: GestureResponderEvent) => {
    e.preventDefault();
    console.log('Dismising keybiard');
    Keyboard.dismiss;
    setCommentInputHidden(false);
    if (!hasUserLoggedIn()) {
      // onGuestUserBottomSheet();
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('QNA Detail page');
      setNavigationParams({
        name: {
          pathname: `/questionDetailList/${id}`,
          query: {
            questionDetail: id,
            authorId: authorIdRef?.current,
          },
        },
        routeName: {
          name: 'questionDetailList/index',
          params: { questionDetail: id },
        },
        description: `${t('page.commentAnswerQnaPage')}`,
        screenName: 'QNA Detail page',
      });
      return;
    }

    if (addReply?.trim()?.length == 0 || isAnswerSubmitting) {
      return;
    }

    setIsAnswerSubmitting(true);

    try {
      // setCommentReplyExpanded(false);
      const payload: IPostQuestionPayload = {
        userId: userProfile?.user?.id!,
        realmId: userProfile?.realm?.id!,
      };

      const body: IPostQuestionBody = {
        type: 'reply',
        name: userProfile?.user?.name ?? '',
        title: addReply,
        body: addReply,
        space: 'qna',
        tags: [`#system_${selectedLanguage ? LanguageJson[selectedLanguage] : 'en'}`],
        creatorid: userProfile?.user?.id || '',
        videoUrls: [],
        audioUrls: [],
        parentid: id,
      };
      const postResponse = await postQuestionReplyAsync(payload, body);
      console.log('🚀 ~ onReplyToQuestion ~ postResponse:', postResponse);
      if (postResponse) {
        postResponse.commentCount = -1;
        const adaptiveActionFormat: any = {
          ...postResponse,
          type: 'QNA',
          mediaDetails: [],
          props: [],
          eventNamePrefix: '',
        };
        setQuestionAnswer([...questionAnswer,adaptiveActionFormat]);
        questionDetail?.children?.push(postResponse);
        setQuestionDetail(questionDetail);
        textAreaRef?.current?.clear();
        setAddReply('');
      }
      const additionalDetails = [
        addEventParam('replyContent', addReply),
        addEventParam('questionId', id),
        addEventParam('authorId', authorIdRef.current),
        addEventParam('deeplinkingUrl', `ninjakisan://questionDetailList/${id}`),
      ];
      const qnaAnswerBoxOpenSuccessEvent: INinjaEvent = {
        name: KissanEventType.QNA_SUBMIT_SUCCESS,
        screenDetails: { screen: 'qna detail page' },
        eventParams: additionalDetails,
      };
      enqueue(qnaAnswerBoxOpenSuccessEvent);
    } catch (error) {
      const additionalDetails = [
        addEventParam('replyContent', addReply),
        addEventParam('errorMessage', error.toString()),
        addEventParam('apiError', safeStringify(error)),
      ];
      const qnaSubmitFail: INinjaEvent = {
        name: KissanEventType.QNA_SUBMIT_FAIL,
        screenDetails: { screen: 'qna detail page' },
        eventParams: additionalDetails,
      };
      enqueue(qnaSubmitFail);
      throw error;
    } finally {
      setIsAnswerSubmitting(false);
    }
  };

  const renderAnswerItem = ({ item, index }: { item: IQnAReplyItem; index: number }) => {
    console.log('🚀 ~ renderAnswerItem ~ item.type):', item.type);
    switch (item.type) {
      case DiscoveryCardType.BANNER_AD:
        return (
          <BannerAds
            deviceWidth={deviceWidth}
            itemKey={item?.itemKey ?? index.toString()}
            unitId={item?.unitId}
            bannerAdKeywords={[]}
            screenName={'discovery page'}
          />
        );

      case IGlobalSearchTab.QNA:
        if (item?.creatorRole === 'mods') {
          return null;
        }
        return (
          <QnAAnswersWithComments
            reply={item}
            showFeedback={true}
            // updateConnectionStatus={updateConnectionStatus}
            // extraData={extraData}
            handleViewProfileClick={handleViewProfileClick}
            pageName={'Qna Detail Page'}
            useQnaFeedStore={useQnaFeedStore}
            createCommentQnA={createCommentQnA}
            getQnACommentList={getQnACommentList}
            onQnAReplyLike={onQnAReplyLike}
            index={index}
          />
        );

      default:
        return null;
    }
  };

  const onEndReached = async () => {
    try {
      console.log('Qna List on end reached callback!!!');
      setOnEndReachedSpinner(true);
      // await initializeQnAList();
    } catch (error) {
      console.error('On End reachred All QnA err => ', error);
    } finally {
      setOnEndReachedSpinner(false);
    }
  };

  // const onGuestUserBottomSheet = () => {
  //   setGuessUserBottomSheet(true);
  // };
  // const navigateToLoginPage = () => {
  //   setGuessUserBottomSheet(false);
  // push('/login');
  // };

  const handleNavigateAskQuestion = () => {
    const qnaContinueAskClickEvent: INinjaEvent = {
      name: KissanEventType.QNA_CONTINUEASK_CLICK,
      screenDetails: { screen: 'qna detail page' },
      eventParams: [
        addEventParam('questionId', id),
        addEventParam('authorId', authorIdRef.current),
      ],
    };
    enqueue(qnaContinueAskClickEvent);
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('QNA page');
      setNavigationParams({
        name: '',
        routeName: { name: qnaNewFlow?.routeName },
        description: `${t('page.askQuestionCtaQnaPage')}`,
        screenName: 'QNA page',
      });
    } else {
      push(qnaNewFlow?.name);
    }
  };

  const hasAnswersByOthers = questionAnswer.some((item) => item?.creatorRole !== 'mods');

  {
    /* Commented this code, may be useful in future */
  }
  // const updateFollowState = (prevState, postOwnerId) => {
  //   console.log('question Answer replies', questionAnswer)
  //   return questionAnswer?.map((el) => {
  //     if (el?.updatedBy === postOwnerId) {
  //       return {
  //         ...el,
  //         actionData: {
  //           ...el.actionData,
  //           content: {
  //             ...el.actionData.content,
  //             following: !prevState,
  //           },
  //         },
  //       };
  //     }
  //     return el;
  //   });
  // };

  // const [needRefresh, setNeedRefresh] = useState<boolean>(false);

  // const updateConnectionStatus = async (isFollowing, postOwnerId) => {
  //   const prevState = isFollowing;
  //   try {
  //     let config = {
  //       type: isFollowing ? 'unfollow' : 'follow',
  //       formData: {
  //         sourceObjectId: userProfile?.user?.id,
  //         sourceObjectType: 'USER',
  //         destinationObjectId: postOwnerId,
  //         destinationObjectType: 'USER',
  //         associationType: 'FOLLOWED',
  //       },
  //     };
  // const response: boolean = await updateFollowStatusApi(config);
  //     const updatedQuestionAnswer = await updateFollowState(response ? prevState : !prevState, postOwnerId);
  //     setQuestionAnswer([...updatedQuestionAnswer]);
  //   } catch (error) {
  //     console.error('Error updating Connection Status', error);
  //     const updatedQuestionAnswer = updateFollowState(!prevState, postOwnerId);
  //     setQuestionAnswer([...updatedQuestionAnswer]);
  //   } finally {
  //     setNeedRefresh(!needRefresh);
  //   }
  // };

  // useEffect(() => {
  //   if (needRefresh) {
  //     console.log('wfvjbkf')
  //     setExtraData(!extraData);
  //     return;
  //   }
  // }, [needRefresh]);

  const handleViewProfileClick = (userId) => {
    const isInvalidOwner = isInvalidPostOwnerId(userId);
    const isCurrentUser = userId === userProfile?.user?.id;
    if (isInvalidOwner)
      return toast.show('', {
        message: `${t('page.profileNotAvailable')}`,
      });
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('QNA Detail page');
      setNavigationParams({
        name: '',
        routeName: isCurrentUser ? '/profileDetail' : { name: `/profile/${userId}` },
        description: `${t('page.viewOnProfilePage')}`,
        screenName: 'QNA Detail page',
      });
    } else {
      push(isCurrentUser ? '/profileDetail' : { pathname: `/profile/${userId}` });
    }
  };

  return (
    <RootContainer flex={1}>
      <XStack
        flexDirection={'row'}
        marginTop={Platform.OS == 'web' ? '$2' : '$8'}
        marginBottom={10}
        paddingHorizontal={16}
      >
        <NavHeaderComponent page={'QuestionAnswerDetailPage'} />
      </XStack>
      <ScrollView horizontal={false} showsVerticalScrollIndicator={false}>
        {isLoading && <QnAPlaceHolder showDetailPage={false} />}
        {!isLoading && (
          <>
            <QuestionAnswerCard
              item={questionDetail}
              index={0}
              questionId={questionDetail?.id}
              showFeedbackOnReplies={true}
              // expertAnswer={questionDetail?.children?.find(
              //   (x) => x?.type == 'QNA' && x?.creatorRole === 'mods'
              // )}
              // showborder={false}
              // sourcePage={'Qna Detail Page'}
              showFollowOnCard={
                questionDetail?.author?.creatorid === userProfile?.user?.id ? false : true
              }
              pageExpertName={'Qna Detail Page'}
              createCommentQnA={createCommentQnA}
              getQnACommentList={getQnACommentList}
              onQnAReplyLike={onQnAReplyLike}
              useQnaFeedStore={useQnaFeedStore}
              lang={lang}
              // onGuestUserBottomSheet={onGuestUserBottomSheet}
            />
            <>
              {/* {expertAnswers && expertAnswers?.length > 0 && (
                  <ExpertAnswerCommentCard expert={expertAnswers[0]} showFeedBackSection={true} />
                )} */}
              <Separator width={4} borderColor={theme['#E4E4E4']?.val} />
              {questionDetail?.bannerAd && (
                <BannerAds
                  deviceWidth={deviceWidth}
                  itemKey={questionDetail?.bannerAd?.actionData?.content.itemKey!}
                  unitId={questionDetail?.bannerAd?.actionData?.content.unitId!}
                  bannerAdKeywords={[]}
                  screenName={'qna detail page'}
                />
              )}
              {questionDetail?.bannerAd && (
                <Separator width={4} borderColor={theme['#E4E4E4']?.val} />
              )}
              {hasAnswersByOthers && (
                <Paragraph
                  color={'$primary'}
                  fontWeight={'600'}
                  fontSize={16}
                  marginTop={15}
                  paddingHorizontal={10}
                  textTransform="uppercase"
                >
                  {t(hasAnswersByOthers ? 'page.answerByOthers' : '')}
                </Paragraph>
              )}

              {questionAnswer && questionAnswer.length > 0 && (
                <XStack paddingTop={5}>
                  <FlashList
                    data={questionAnswer}
                    renderItem={renderAnswerItem}
                    keyExtractor={(item, index) => `${item?.id}-${index}`}
                    extraData={extraData}
                    showsHorizontalScrollIndicator={false}
                    showsVerticalScrollIndicator={false}
                    estimatedItemSize={450}
                    numColumns={1}
                    onEndReached={onEndReached}
                    ListFooterComponent={() => {
                      if (onEndReachedSpinner) {
                        return (
                          <View style={{ flex: 1, padding: 10, alignItems: 'center' }}>
                            <Spinner size="large" color="$green10" />
                          </View>
                        );
                      }
                      return null;
                    }}
                    ListFooterComponentStyle={{ height: 100 }}
                  />
                </XStack>
              )}
            </>
          </>
        )}
      </ScrollView>

      {!isLoading &&
        (!isCommentInputHidden && !isAskQuestionDetailPage ? (
          <XStack
            flexDirection="row"
            alignItems="center"
            borderTopColor={'#EEE'}
            borderTopWidth={1}
            width={'100%'}
            position={'absolute'}
            bottom={2}
            backgroundColor={'$inputBg'}
          >
            <XStack width={'83%'} backgroundColor={'$inputBg'}>
              <TextArea
                style={{ backgroundColor: '$inputBg', borderRightColor: 'transparent' }}
                onChangeText={(text) => setAddReply(text)}
                ref={textAreaRef}
                placeholder={t('page.typeYourAnswerHere')}
                backgroundColor={'$inputBg'}
                placeholderTextColor={'$grey'}
                padding={10}
                fontSize={16}
                height={80}
                width={'100%'}
              />
            </XStack>

            <XStack width={'17%'} backgroundColor={'$inputBg'}>
              <Stack
                borderRadius={50}
                borderWidth={1}
                borderColor={'rgba(115, 115, 115, 0.40)'}
                backgroundColor={
                  addReply.trim()?.length !== 0 && !isAnswerSubmitting ? '$primary' : '$grey'
                }
                padding={8}
                width={40}
                height={40}
                marginTop={15}
                marginLeft={18}
                // onPress={() => !isAnswerSubmitting && onReplyToQuestion()}
                onPress={onReplyToQuestion}
                testID="kisan_tId_questionDetailList_click"
              >
                <SendHorizontal color={'#FFF'} size={22} />
              </Stack>
            </XStack>
          </XStack>
        ) : (
          isAskQuestionDetailPage && (
            <XStack
              justifyContent="center"
              alignItems="center"
              paddingHorizontal={10}
              paddingVertical={10}
              backgroundColor={'$background'}
              position="absolute"
              bottom={0}
              width="100%"
              borderTopColor={'$cropBorderColor'}
              borderTopWidth={1}
            >
              <Button
                backgroundColor={'$primary'}
                onPress={handleNavigateAskQuestion}
                theme="active"
                fontWeight={'600'}
                letterSpacing={'$10'}
                borderRadius="$2"
                color={'#fff'}
                width={'100%'}
                size="$6"
                paddingBottom="$2"
                marginBottom="$3"
                testID={`kisan_tId_continueAsking_click`}
              >
                {t('page.continueAsking')}
              </Button>
            </XStack>
          )
        ))}

      <UIBottomSheet
        open={qnaFeedbackbottomSheet}
        animation={'quick'}
        onOpenChange={setQnaFeedbackbottomSheet}
        snapPoints={[65]}
        children={<QnaSubmitFeedback bottom={10} />}
      />
    </RootContainer>
  );
};
